import { Injectable } from '@angular/core';
import { catchError, Observable, of, ReplaySubject } from 'rxjs';
import {
  AnalyzedConsumption,
  newAnalysisDay,
  Prediction,
  SmartScore
} from './analyse.types';
import { AnalyseService } from './analyse.service';
import { theTime } from 'src/app/utils/date-utils';

@Injectable({
  providedIn: 'root'
})
export class AnalyseDataService {
  selectedObjectId: string;

  private _analyzedConsumptionData$ = new ReplaySubject<AnalyzedConsumption>(
    undefined
  );
  private _smartScoreData$ = new ReplaySubject<SmartScore>(undefined);
  private _predictionData$ = new ReplaySubject<Prediction>(undefined);

  analyzedConsumption$: Observable<AnalyzedConsumption | undefined> =
    this._analyzedConsumptionData$.asObservable();
  smartScore$: Observable<SmartScore | undefined> =
    this._smartScoreData$.asObservable();
  prediction$: Observable<Prediction | undefined> =
    this._predictionData$.asObservable();

  constructor(private _analyseService: AnalyseService) { }

  reset() {
    this._analyzedConsumptionData$ = new ReplaySubject<AnalyzedConsumption>(
      undefined
    );
    this._smartScoreData$ = new ReplaySubject<SmartScore>(undefined);
    this._predictionData$ = new ReplaySubject<Prediction>(undefined);

    this.analyzedConsumption$ = this._analyzedConsumptionData$.asObservable();
    this.smartScore$ = this._smartScoreData$.asObservable();
    this.prediction$ = this._predictionData$.asObservable();
  }

  fetchData(objectId: string) {
    if (objectId) {
      this.selectedObjectId = objectId;
      const now = theTime();
      let selectedPeriod = '';
      let selectedSmartScorePeriod = '';

      if (now.getDate() < newAnalysisDay) {
        selectedPeriod = '-1';
      } else {
        selectedPeriod = now.to(['YYYY', 'MM']);
      }

      if (now.getDate() < newAnalysisDay) {
        selectedSmartScorePeriod = now.goes("MM", -1).to(["YYYY", "MM"]);
      } else {
        selectedSmartScorePeriod = undefined;
      }

      this._analyseService
        .getAnalyzePeriod(objectId, selectedPeriod)
        .pipe(catchError((err) => of({} as AnalyzedConsumption))) // fallback to empty object instead of error, avoid subject completion
        .subscribe({
          next: (res) => {
            this._analyzedConsumptionData$.next(res);
          }
        });
      let smartscoreRequest: Observable<SmartScore>;

      if (selectedSmartScorePeriod) {
        smartscoreRequest = this._analyseService.getSmartScorePeriod(
          objectId,
          selectedSmartScorePeriod
        );
      } else {
        smartscoreRequest = this._analyseService.getSmartScore(objectId);
      }
      smartscoreRequest
        .pipe(catchError((err) => of({} as SmartScore))) // fallback to empty object instead of error, avoid subject completion
        .subscribe({
          next: (res) => {
            this._smartScoreData$.next(res);
          }
        });
    }
  }

  fetchChemX(objectId?: string) {
    const oId = objectId || this.selectedObjectId;
    this._analyseService.getChemX(oId).subscribe({
      next: (res) => {
        this._predictionData$.next(res);
      },
      error: (err) => {
        this._predictionData$.error(err);
      }
    });
  }
}
